var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-group",
    class: {
      'form-error': _vm.error,
      'with-sub-label': _vm.subLabel != null
    }
  }, [_vm.label != null ? _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm.subLabel ? _c('div', {
    staticClass: "sub-label"
  }, [_c('small', [_vm._v(_vm._s(_vm.subLabel))])]) : _vm._e(), _vm.$attrs.type != 'textarea' ? _c('input', _vm._g(_vm._b({
    ref: "input",
    attrs: {
      "type": _vm.$attrs.type ? _vm.$attrs.type : 'text',
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleFileChange
    }
  }, 'input', _vm.$attrs, false), _vm.listeners)) : _c('textarea', _vm._g(_vm._b({
    staticStyle: {
      "resize": "vertical"
    },
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  }, 'textarea', _vm.$attrs, false), _vm.listeners)), _vm.error ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }